import { wrapReducer } from "@client/content/lib/helper";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type InitSuccessActionData, type SetShowingDetailIdActionData } from "./actions";
import { type MemberVouchers } from "./types";

const reducer = (state: MemberVouchers.AppState = defaultState, action: ReduxAction<any>): MemberVouchers.AppState => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: Status.Loading
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: Status.Failed
      };
    }
    case Actions.InitSuccess: {
      const { vouchers } = action.data as InitSuccessActionData;
      return {
        ...state,
        vouchers,
        status: Status.Ready
      };
    }

    case Actions.SetShowingItemId: {
      const { itemId } = action.data as SetShowingDetailIdActionData;
      return {
        ...state,
        showingVoucherId: itemId
      };
    }
    default:
      return state;
  }
};

export const defaultState: MemberVouchers.AppState = {
  error: null,
  id: "",
  status: Status.None,
  vouchers: [],
  showingVoucherId: null
};
export const previewState: MemberVouchers.AppState = {
  ...defaultState,
  status: Status.Ready,
  vouchers: [
    {
      amount: 100,
      currencyCode: "USD",
      expiryDate: new Date().toISOString(),
      issueDate: new Date().toISOString(),
      statusName: "Active",
      voucherCode: "Dummy",
      voucherCodeId: ""
    }
  ]
};
export default wrapReducer({ defaultState, reducer, previewState });
